import { pause, unpause, is_paused } from './ajax-helpers.js';

let $,
	page,
	wrapper,
	locationCount,
	locationCountPlural,
	existingLocations,
	locationType,
	taxonomySlug,
	lastPage,
	searchTimeout,
	categoryInput,
	searchInput,
	newLocationTemplate,
	categories;

/**
 * Fetches and displays locations from the WordPress REST API.
 * @param {boolean} nextPage - True to fetch the next page, false to fetch the first page.
 * @param {boolean} [force=false] - True to bypass the 'paused' state check.
 */
function getLocations(nextPage, force = false) {
	if (!force && (is_paused(wrapper) || (nextPage && lastPage))) {
		return;
	}

	pause(wrapper);

	const nextPageNum = nextPage ? page + 1 : 1;
	const postPath = `/wp-json/wp/v2/${locationType}`;

	const query = {
		page: nextPageNum,
	};

	const categoryValue = categoryInput.val();
	if (categoryValue) {
		query[taxonomySlug] = categoryValue;

		// For vibemap_place, also pass the selected filter id so the
		// `bid_primary_category` REST field can swap each row's badge to
		// match the filter — see modules/vibemap-place.php.
		if (locationType === 'vibemap_place') {
			query.bid_filter_category = categoryValue;
		}
	}

	const searchValue = searchInput.val();
	if (searchValue && locationType == 'vibemap_place') {
		query.bid_plp_search = searchValue;
	} else {
		query.search = searchValue;
	}

	if (query.search) {
		query.orderby = 'relevance';
		query.order = 'desc';
	} else if (locationType === 'business' || locationType === 'vibemap_place') {
		query.orderby = 'title';
		query.order = 'asc';
	} else {
		query.orderby = 'date';
		query.order = 'asc';
	}

	let retryAttempts = 3;

	const ajaxArgs = {
		method: 'GET',
		dataType: 'json',
		data: query,
		success: (locations, textStatus, jqXHR) => {
			const resultCount = parseInt(jqXHR.getResponseHeader('X-WP-Total'), 10);
			const lastPageNum = parseInt(jqXHR.getResponseHeader('X-WP-TotalPages'), 10);

			if (!nextPage) {
				lastPage = false;
				existingLocations.empty();
			}

			if (locations.length === 0 || lastPageNum <= nextPageNum) {
				lastPage = true;
			}

			locationCount.text(resultCount);
			locationCountPlural.toggle(resultCount !== 1);

			if (locations.length > 0) {
				locations.forEach(location => {
					// Replace category IDs with full category objects for the template.
					if (location[taxonomySlug] && Array.isArray(location[taxonomySlug])) {
						location[taxonomySlug] = location[taxonomySlug].map(catId => categories[catId]);
					}

					existingLocations.append(ejs.render(newLocationTemplate, { location }));
				});
			}

			page = nextPageNum;
			unpause(wrapper);
		},
		error: () => {
			if (retryAttempts > 0) {
				retryAttempts--;
				$.ajax(postPath, ajaxArgs);
			} else {
				unpause(wrapper);
			}
		}
	};

	$.ajax(postPath, ajaxArgs);
}

/**
 * Initializes the locations listing page functionality.
 */
function initLocationsPLP() {
	$ = jQuery;
	wrapper = $('[data-js="location-listing-page"]');

	if (wrapper.length === 0) {
		return;
	}

	// Initialize variables
	page = 1;
	newLocationTemplate = wrapper.find('[data-js="location-template"]').html();
	locationType = wrapper.data('post-type');
	locationCount = wrapper.find('[data-js="location-count"]');
	locationCountPlural = wrapper.find('[data-js="location-count-plural"]');
	existingLocations = wrapper.find('[data-js="location-listing"]');
	searchInput = wrapper.find('[data-js="search-filter"]');
	categoryInput = wrapper.find('[data-js="category-filter"]');
	lastPage = false;
	categories = {};

	// Determine the correct taxonomy slug based on the post type.
	taxonomySlug = locationType === 'vibemap_place'
		? 'vibemap_place_category'
		: `${locationType}-category`;

	// Fetch the categories used to populate the filter dropdown. For
	// vibemap_place we restrict to visible top-level categories via the
	// custom `bid_top_level_only` param handled in modules/vibemap-place.php.
	const categoryQuery = locationType === 'vibemap_place'
		? '?per_page=100&bid_top_level_only=1'
		: '?per_page=100';
	const categoryPath = `/wp-json/wp/v2/${taxonomySlug}${categoryQuery}`;
	let retryAttempts = 3;

	const fetchCategoriesArgs = {
		method: 'GET',
		dataType: 'json',
		success: (data) => {
			if (Array.isArray(data)) {
				data.forEach(category => {
					categories[category.id] = category;
				});
			}

			// Set up event listeners after categories are loaded.
			categoryInput.on('change', () => {
				getLocations(false);
			});

			searchInput.on('keyup', () => {
				clearTimeout(searchTimeout);
				searchTimeout = setTimeout(() => {
					getLocations(false);
				}, 500);
			});

			$(window).on('scroll', () => {
				const windowHeight = window.innerHeight;
				const windowBottom = window.scrollY + windowHeight;
				const postsBottom = existingLocations.offset().top + existingLocations.outerHeight();

				// Load more posts when user scrolls near the bottom.
				if (windowBottom >= postsBottom - 100) { // 100px buffer
					getLocations(true);
				}
			});

			// Initial load of locations.
			getLocations(false, true);
		},
		error: () => {
			if (retryAttempts > 0) {
				retryAttempts--;
				$.ajax(categoryPath, fetchCategoriesArgs);
			} else {
				unpause(wrapper);
			}
		}
	};

	pause(wrapper);
	$.ajax(categoryPath, fetchCategoriesArgs);
}

export { initLocationsPLP };